import { render } from "./UserMailFilterSettings.vue?vue&type=template&id=103fdd0d"
import script from "./UserMailFilterSettings.vue?vue&type=script&lang=ts"
export * from "./UserMailFilterSettings.vue?vue&type=script&lang=ts"
script.render = render

export default script